<template>
  <div class="hcl-block-content-form" v-bind="attributesMeta(props.definition.meta)">
    <form :name="formName" :action="formAction" method="post">
      <hcl-form :name="props.definition.form.config.name" :definition="props.definition.form" :data="bucket"
        :parent-meta-id="props.definition.meta.id"></hcl-form>
    </form>
  </div>
</template>

<script setup lang="ts">
import { provide } from 'vue'

import HclForm from '@/components/Form/Form.vue'

import { useMeta } from '@/composables/meta'

import { DefinitionBlockContentForm } from '@/components/types'

import { useDataStore } from '@/stores/data'

interface Props {
  /**
   * Definition as an JS object.
   */
  definition: DefinitionBlockContentForm
}

const props = withDefaults(defineProps<Props>(), {
  definition: undefined
})

const { attributesMeta } = useMeta()

provide('blockContentMetaId', props.definition.meta.id)

const formName = props.definition.form.config.name ?? ''
const formAction = props.definition.form.config.action ?? '.'

const { link } = useDataStore()

const bucket = link(props.definition.meta.id)
</script>
